import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { Options } from 'selenium-webdriver'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class InstructionService {
	constructor(private http: HttpClient) { }
    
    type(type: any, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.instruction:type',
            params: {
                type: type,
                options: options
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    
    
	new(type: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:new',
			params: {
				type: type,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	get(id: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:get',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
    getMulti(ids: any, options: any= []){
        let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:getMulti',
			params: {
				ids: ids,
				options: options,
			},
		})
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
	set(type: any, id: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:set',
			params: {
				type: type,
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

    setMulti(type: any, id: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:setMultiInstructions',
			params: {
				type: type,
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	annuler(id: string): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:annuler',
			params: {
				id: id,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
    annulerGroup(options:any =[]): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:cancelGroup',
			params: {
				options: options
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	setTransitionInstruction(instruction: any): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:set',
			params: {
				type: instruction.type.key,
				id: instruction.ID,
				options: {
					transition: instruction.transitionid,
					transition_demande_type: instruction.transition_demande_type,
					instructeur: instruction.instructeurid,
					titre: instruction.titre,
					comment: instruction.comment
					
				},
			},
		})

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getEtapesInstruction(instruction: any): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:getEtapesInstruction',
			params: {
				id: instruction.ID
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

    recoverToEtape(instruction: any, etape): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:recoverToEtape',
			params: {
				id: instruction.ID,
				etape: etape,
				options: {
					idDemandeType: instruction.demandeType,
					titre: instruction.titre,
					comment: instruction.comment,
					instructeur: instruction.instructeurid,
				},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

    setTransitionGroupe(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:setTransitionGroupe',
			params: {
				options:options
			},
		})

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	formulaires(id: string, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.instruction:formulaires',
            params: {
                id: id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    
    getBy(type: string, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.instruction:getby',
            params: {
                type: type,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    
    change(id: string,type: string, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.instruction:change',
            params: {
                id: id,
                type: type,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    transitions(id: string, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.instruction:transitions',
            params: {
                id: id,
                
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    transitionsGroup(options:any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.instruction:transitionsGroup',
            params: {
                options:options
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    getProcedureTypeList(options:any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.instruction:getProcedureTypeList',
			params: {
                options:options
            }
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    getStatutList(): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.instruction:getStatutList',
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    setMultipleID(options:any): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.instruction:setMultipleID',
            params: {
                opt:options,
            }
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    
   historique(id: string, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.instruction:historique',
            params: {
                id: id,
                options: options
            }
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    
    droit(id: string, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.instruction:droit',
            params: {
                id: id,
                options: options
            }
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    
    lock(formid: any,etat:number=1): Observable<any> {
	    let rpcMethod = new JSONRpc({
	      jsonrpc : "2.0",
	      method:"webservice.formulaire:lock",
	      params: {
	        id: formid,
	        etat: etat,
	        options : {}
	      }
	    })
	    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
	  }

    

 
}
